import React from 'react';
import GoogleMapReact from 'google-map-react';

const MyGoogleMap = () => {
    const defaultProps = {
        center: {
            lat: 25.770871004763332,
            lng: -80.18999143934927
        },
        zoom: 14
    };

    const handleApiLoaded = (map, maps) => {
        // AdvancedMarkerElement vive en la librería "marker"
        new maps.marker.AdvancedMarkerElement({
            position: defaultProps.center,
            map,
        });
    };

    return (
        <div style={{ height: '550px', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                    libraries: ['marker'], // necesario para AdvancedMarkerElement
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                options={{
                    mapId: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID, // obligatorio
                }}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            />
        </div>
    );
};

export default MyGoogleMap;
